
import React from 'react'
import { Box, HBox, VBox } from './Box'
import Avatar from './Avatar'
import Menu from './Menu'
import Text from './Text'

/**
 * AccountMenu component.
 */

export default function AccountMenu({ user, onSelect }) {
  return <Box>
    <VBox alignX="center" paddingY={8} lineHeight={1.5} borderBottom>
      <Avatar name={user.name || user.email} marginBottom={3} />
      {user.name && <Text userSelect="none">{user.name}</Text>}
      <Text userSelect="none" muted>{user.email}</Text>
    </VBox>

    <Menu full>
      <Menu.Group>
        <Menu.Item onSelect={onSelect} to="/account/settings">Profile</Menu.Item>
        <Menu.Item onSelect={onSelect} to="/logout">Sign out</Menu.Item>
      </Menu.Group>
    </Menu>
  </Box>
}
